export enum JobTrait {
  WAITING_ON_DELIVERY = "WAITING_ON_DELIVERY",
  TEMPORARILY_HANDED_OUT = "TEMPORARILY_HANDED_OUT",
}
